import { createEmptyAction } from "chalet-shared";

export const actionCreators = {
    rosterSortMoratoriumOn: createEmptyAction("ROSTER_SORT_MORATORIUM_ON"),
    rosterSortMoratoriumOff: createEmptyAction("ROSTER_SORT_MORATORIUM_OFF"),
};
